var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    fill: "url(#pattern0_2352_499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2352_499",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2352_499",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2352_499",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADiElEQVR4nO3cz0sWQRzH8UVvaWmZnis7ee0PEdIiFDVvZXXuXhhC5r8giEpuf4QVWGYZaUb9BdJP0q5p7xgcwUKc2d1Zn2ef+bxgr7Pzna+z8/MxSURERERERERERERERERERERERERERESkXEAXcAUYB54Az4A3AZ6JAHWbCFSXpzY2E2M/0JnUE+A0cAdYAf5QjjRAPdOS6mZiXgZuAe1hWjV/Isxf3S/Kl9ZxQg7aBh4ce2KAIeALxyetSEL2fQYGw7T20UGdBOY4fmnFErJvBmgN0/qHD9ir1EZa0YRgJwJdYbLwbzI+UTtphROCbbvOkJ+pWvWMRkmI8RpoCZGQPGPGb2AJmAWm7GysyDMYII7BAPWYsjG9sDFmNRNiNpXFO2AYOJM0OKDDxrqWsY0GiqwzfKe232zympLIAE3ACPA9w5Q4+zrFdlEf74HzSeSAbmDDs83G8/SObc9knCotyooB2jyTspWpl9i9KRfTRbtLjbCCgHPAV4/2G8tSqNkodBkqNbIKs2OKy8ssi0DXru1ajAN4xoH+raMNTRuf9Snsqkd2h71rd/g7eoBLdf70FIzxukc79vsUZA5ejmIWRB0FK+s7G6mljQDrFNfi8Z5PQeY07ChLRSoaS0IMM0443rGQuADPHYXMOgtxvyOWhMw73rHoU4hrMHoYoKKxJGTS8Y7VEAmZDFDRWBLyKERCXJ+suQAVjSUhj0N8sjSo19mg7pr27ngtaCLvIQSc9pqLbi4jBSsbw8Jw1KMd+3wK6vTYOlkHmotUuJEBzXYn/Ci73l8aexOv1F7SyPDrHf4LbOC2R4E/gIulRlZB5rDOnqC63MhSaLvnAZUZnNtKjbB6B1QfPNrtZ+Z2s3dU8UzKhSRy7B3h+iTDuJ/nBe32QB7P08ORGM9I2BvAR+0n3Mdm7mNve5cpi3V7DlBoe74KzAzJxuqaTf3vWtEXmwvDWe3YVeq8vVx2t+DTG6ABewPUY8rGtGxjzGo6CRBIq70GWUtpA1wlfQWcKJyQA4tFXbbO72Pwn76Z66H2TmstpBXuISvBf45wIKiWnGNKrAmZDvaZcgQ3kGFKHGNCNgvPpnKuU8Y9V/SxJGTLLPpqunthtwvG7DTX7GDGlpBd+1uYm3W3jWQXS332r2TBHFE24D8OWLSxmRgvx7AIFhEREREREREREREREREREREREREREUlq7S8355gUsyRN7QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.e034df50cddd5fa95dff8636d0d5e54b.svg";
export { ForwardRef as ReactComponent };